const cart: any = [];

const handleCart = (state = cart, action: any) => {
  const product = action.payload;
  switch (action.type) {
    case "ADDITEM":
      const exist = state.find((data: any) => data.id === product.id);
      if (exist) {
        return state.map((data: any) =>
          data.id === product.id ? { ...data, qty: data.qty + 1 } : data
        );
      } else {
        const product = action.payload;
        return [
          ...state,
          {
            ...product,
            qty: 1,
          },
        ];
      }
    case "DELITEM":
      const doesExist = state.find((data: any) => data.id === product.id);
      if (doesExist?.qty === 1) {
        return state.filter((data: any) => data.id !== doesExist?.id);
      } else {
        return state.map((data: any) =>
          data.id === product.id ? { ...data, qty: data.qty - 1 } : data
        );
      }
    default:
      return state;
  }
};

export default handleCart;
